


















































// vendor
import { defineComponent, computed, ref } from "@vue/composition-api";
// project
import { useLang } from "@lang";
// local
import { default as FBInstructions } from "./fb-instructions.vue";

export default defineComponent({

	emits:[],
	props:{
	},
	components:{
		"fb-instructions":FBInstructions,
	},
	setup(props, context){

		const {
			translate,
		} = useLang(context);
		
		const title = computed(() => {
			// return "...hang on!";
			return translate("session.message.facebookWarningTitle");
		});
		
		const subtitle = computed(() => {
			// return `You appear to be visiting through <span class="font-weight-bold">facebook</span>.`;
			return translate("session.message.facebookWarningInfo");
		});

		const description = computed(() => {
			// return `For our site to work correctly (and to prevent facebook looking over your shoulder) please switch to your normal browser.`
			return translate("session.message.facebookWarningSwitch");
		});

		return {
			title,
			subtitle,
			description,
		};
	}
});

